import { z } from 'zod';

const DisplayPerf = z.preprocess(
  (v) => (v === '' || v === null || v === undefined ? undefined : v),
  z.coerce.number().min(0).max(1_000_000_000).optional(),
);

/** Admin — 系谱业绩：清零 / 重算叠回 / 钉死 L/R */
export const AdminPerfOpsSchema = z
  .object({
    action: z.enum(['zero', 'restack', 'pin']),
    /** zero: 清零范围 */
    zero_scope: z
      .enum(['self', 'binary_subtree', 'left_leg', 'right_leg'])
      .optional()
      .default('binary_subtree'),
    /** restack: 跳过 note 含 [pin]/平移 的节点（保留人工钉死） */
    preserve_pinned: z.preprocess(
      (val) => val === true || val === 'true' || val === 1 || val === '1' || val === undefined,
      z.boolean(),
    ).default(true),
    /** pin: 显示单位（表上 L/R，即 raw÷1000）；留空表示该侧不改 */
    left_display: DisplayPerf,
    right_display: DisplayPerf,
    confirm_username: z.string().min(1).max(32),
    note: z.string().min(3).max(500),
    xian: z.boolean(),
  })
  .superRefine((v, ctx) => {
    if (v.action === 'pin' && v.left_display == null && v.right_display == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '钉死 L/R 至少填写一侧显示业绩',
        path: ['left_display'],
      });
    }
  });

export type AdminPerfOpsRequest = z.infer<typeof AdminPerfOpsSchema>;
